import { useLayoutEffect, useRef, useState } from "react";

export const useIsTruncated = (dependency) => {
  const ref = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useLayoutEffect(() => {
    const label = ref.current?.querySelector(".MuiChip-label");
    setIsTruncated(!!label && label.scrollWidth > label.clientWidth);
  }, [dependency]);

  return [ref, isTruncated];
};
